import React, { useEffect, useState } from 'react';
import { Modal, Button, TextInput, Textarea, Spinner } from 'flowbite-react'; // or your preferred UI lib
import EquipApi from '../../Api/EquipmentApi';
import { useAppSelector } from '../../Reducers/store';
import { Equipment } from '../../Models/Equipment';

interface EmailModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSendSuccess?: () => void;
  equipment: Equipment;
}

const EmailModal: React.FC<EmailModalProps> = ({
  isOpen,
  onClose,
  onSendSuccess,
  equipment,
}) => {
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [isSending, setIsSending] = useState(false);
  const [error, setError] = useState('');
  const { userModel } = useAppSelector((state) => state.user);

  useEffect(() => {
    if (isOpen) {
      setSubject('Please check warehouse lookup ' + equipment?.number);
      setMessage(
        'Please check warehouse lookup ' +
          equipment?.number +
          ' from ' +
          equipment.manufacturer?.name +
          '.'
      );
    }
  }, [isOpen]);

  const handleSend = async () => {
    setIsSending(true);
    setError('');

    try {
      const userId = userModel?.id ?? 0;
      const equipId = equipment?.id ?? 0;
      await EquipApi.SendEquipmentAvailabilityRequest(
        subject,
        message,
        userId,
        equipId
      ).then((res) => {
        if (res.data) {
          const data = res.data;
          if (data.success) {
            onSendSuccess?.();
            setSubject('');
            setMessage('');
            onClose();
          }
        }
      });
    } catch (err: any) {
      setError(err.message || 'Unexpected error');
    } finally {
      setIsSending(false);
    }
  };

  return (
    <Modal show={isOpen} onClose={onClose}>
      <Modal.Header>Send Email</Modal.Header>
      <Modal.Body>
        <div className='space-y-4'>
          <TextInput
            placeholder='Subject'
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
          />
          <Textarea
            rows={6}
            placeholder='Message'
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
          {error && <p className='text-red-500 text-sm'>{error}</p>}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button color='gray' onClick={handleSend} disabled={isSending}>
          {isSending ? <Spinner size='sm' /> : 'Send'}
        </Button>
        <Button color='gray' onClick={onClose}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EmailModal;
